"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rfidTagDumpTruckColumnFullWidthProps = exports.rfidTagDumpTruckColumnProps = void 0;
exports.rfidTagDumpTruckColumnProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '400px',
        filter: 'text'
    },
    {
        show: true,
        field: 'dumptruck_no',
        title: 'Dump Truck No',
        width: '200px',
        filter: 'text'
    },
    {
        show: true,
        field: 'rfid_tag',
        title: 'Tag Id',
        width: '500px',
        filter: 'text',
    },
];
exports.rfidTagDumpTruckColumnFullWidthProps = [
    ...exports.rfidTagDumpTruckColumnProps
];
exports.rfidTagDumpTruckColumnFullWidthProps[0] = {
    show: true,
    field: 'contractor_name',
    title: 'Contractor',
    width: 'auto',
    filter: 'text'
};
